// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"51ea964b","200":"160dca82","827":"898b6348"}[chunkId] + ".chunk.js";
};